var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9167 22.1667C31.2758 19.855 33.6667 17.0842 33.6667 13.4583C33.6667 11.1487 32.7492 8.93374 31.1161 7.30061C29.4829 5.66748 27.2679 4.75 24.9583 4.75C22.1717 4.75 20.2083 5.54167 17.8333 7.91667C15.4583 5.54167 13.495 4.75 10.7083 4.75C8.39874 4.75 6.18374 5.66748 4.55061 7.30061C2.91748 8.93374 2 11.1487 2 13.4583C2 17.1 4.375 19.8708 6.75 22.1667L17.8333 33.25L28.9167 22.1667Z",
    stroke: "#004B6B",
    strokeWidth: 3.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 7.91667L13.1467 12.6033C12.825 12.9227 12.5696 13.3026 12.3954 13.7211C12.2212 14.1395 12.1315 14.5884 12.1315 15.0417C12.1315 15.495 12.2212 15.9438 12.3954 16.3623C12.5696 16.7808 12.825 17.1606 13.1467 17.48C14.445 18.7783 16.5192 18.8258 17.8967 17.5908L21.1742 14.5825C21.9957 13.8371 23.0653 13.4241 24.1746 13.4241C25.2839 13.4241 26.3535 13.8371 27.175 14.5825L31.8617 18.7942M27.3333 23.75L24.1667 20.5833M22.5833 28.5L19.4167 25.3333",
    stroke: "#004B6B",
    strokeWidth: 3.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.0fca69befdb16503f8ca5c05358cb303.svg";
export { ForwardRef as ReactComponent };